import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	makeStyles, Tooltip
} from '@material-ui/core';
//icons
import AddIcon from "@material-ui/icons/Add";
import Form from "@rjsf/material-ui";
import React, { useState } from 'react';
import { useActions } from 'kea';


import { formSchema, uiSchema } from '../components/schema';
import alertlogic from 'src/store/alert';


const useStyles = makeStyles((theme) => ({
	paper: {
		maxWidth: '200px'
	},
}));


const CreateAlertDialog = () => {
	const classes = useStyles();

	const [open, setOpen] = useState(false);
	const { create } = useActions(alertlogic);


	const handleClickOpen = () => {
		setOpen(true);
	}

	const handleClose = () => {
		setOpen(false);
	}

	const onSubmit = async (value) => {
		let new_alert = {
			name: value.formData.name,
			condition: {
				monitor: value.formData.type,
				condition: '>',
				value: value.formData.value
			}
		}
		if (value.formData.value2) {
			new_alert.condition.value2 = value.formData.value2;
		}
		create(new_alert);
		setOpen(false);
	}

	const validate = (formData, errors) => {
		if (formData.type === 'offline' && formData.value < 1) {
			errors.value.addError('Please enter value greater than 0.');
		}
		return errors;
	}

	return (
		<div style={{ paddingTop: '15px' }}>
			<Tooltip title='Create a new Alert'>
				<Button
					color="primary"
					size="large"
					variant="contained"
					aria-label="add"
					onClick={handleClickOpen}
					startIcon={<AddIcon />}
				>
					New Alert
				</Button>
			</Tooltip>
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="form-dialog-title"
				maxWidth='xs'
				// style={{ maxWidth: '300px' }}
				className={{
					paperWidthXs: classes.paper
				}}
			>
				<DialogTitle id="form-dialog-title">
					Create a new Alert
				</DialogTitle>
				<DialogContent>
					<Form
						schema={formSchema}
						onSubmit={onSubmit}
						uiSchema={uiSchema}
						validate={validate}
						// liveValidate
						showErrorList={false}
					>
						<div style={{ textAlign: 'center', paddingTop: '15px' }}>
							<Button type={'submit'} variant="contained" color="primary">
								Create
							</Button>
						</div>
					</Form>
				</DialogContent>
				<DialogActions>
				</DialogActions>
			</Dialog>
		</div>
	)
}


export default CreateAlertDialog
